import { getDaysSince } from '~/src/common/utilities/utilities';

import { RECENTLY_PUBLISHED_CONTENT_THRESHOLD_IN_DAYS } from './constants';

type Content = {
  entry_date?: {
    yyyymmdd: string;
  };
};
export function isRecentlyPublished({ entry_date }: Content) {
  return entry_date?.yyyymmdd
    ? getDaysSince(new Date(entry_date.yyyymmdd)) < RECENTLY_PUBLISHED_CONTENT_THRESHOLD_IN_DAYS
    : false;
}
